const dateFilterEnum = {
	30: {
		value: 'last30Days',
		label: 'Last 30 Days',
		days: 30,
	},
	90: {
		value: 'last90Days',
		label: 'Last 90 Days',
		days: 90
	},
};

export { dateFilterEnum };
